import styled from '@emotion/styled';

export const Image = styled.img`
  user-select: none;
  -webkit-user-drag: none; // 이미지 드래그 제한
`;
